<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="appTitleOpen">
          {{ productProtection }}
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import urlUtils from 'utils/url';

export default {
  name: 'TheTitle',
  props: {
    eventName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'recharge',
    },
  },
  data: () => ({
    productFromUrl: urlUtils.getProductFromDomain(),
    productProtection: '',
  }),
  methods: {
    setProductProtection() {
      if (urlUtils.getIsAthleteShield()) {
        this.productProtection = 'AthleteShield Ticket Protection';
      } else if (this.productFromUrl === 'enhancedrefundprogram') {
        const clientName = this.$parent.widgetData.client_display_name;
        this.productProtection = `${clientName ? `${clientName}'s ` : ''}Enhanced Refund Program`;
      } else if (this.productFromUrl === 'regshield') {
        this.productProtection = 'RegShield Registration Protection';
      } else {
        this.productProtection = 'FanShield Ticket Protection';
      }
    },
  },
  mounted() {
    this.setProductProtection();
  },
};
</script>

<style scoped>
.appTitle {
  height: auto;
  width: 488px;
  font-family: Gotham;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0 auto;
  word-break: break-word;
}

.appTitleOpen {
  height: auto;
  font-family: Gotham;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  margin: 0 auto;
  word-break: break-word;
}

/* Tablet Break Point */
@media screen and (max-width: 1264px) {}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appTitle {
    width: 259px;
  }
}
</style>
